import { Checkbox, Fade, FormControlLabel } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Title from '../../Title/title';
import ActionsButton from '../ConfirmationModal/ActionButton';
import BoxModalStyled from '../styled';
import { CloseIconModalStyled, ModalStyled } from './styled';

interface DeleteContentModalInterface {
    handleClose: () => void;
    openModal: boolean
    handleClickConfirm: () => void | Promise<void>
    title: string
    checkboxLabel?: string
    handleCheckbox?: (checked: boolean) => void
}

const DeleteContentModal: FC<DeleteContentModalInterface> = ({ handleClose, openModal, handleClickConfirm, title, checkboxLabel, handleCheckbox }) => {
    const { t } = useTranslation('common');
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        setIsLoading(true);
        await handleClickConfirm();
        setIsLoading(false);
    };

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <BoxModalStyled>
                    <Title content={title} modalTitle />
                    <CloseIconModalStyled onClick={handleClose} />
                    {handleCheckbox && (
                        <FormControlLabel
                            control={
                                <Checkbox onChange={(e) => handleCheckbox(e.target.checked)} />
                            }
                            label={checkboxLabel ?? ''}
                        />
                    )}
                    <ActionsButton
                        handleClickCancel={handleClose}
                        handleClickConfirm={handleConfirm}
                        isLoading={isLoading}
                        labelCancel={t('cancel')}
                        labelConfirm={t('confirm')}
                    />
                </BoxModalStyled>
            </Fade>
        </ModalStyled>
    );
};

export default DeleteContentModal;
